<div class="modal-height">
  <ziro-loading-block [cssClass]="cssClass" [hidden]="!isLoading"></ziro-loading-block>
  <ziro-voicemail
    (voicemailRefUpdated)="onVoicemailRefUpdated($event)"
    (showLoading)="setLoading($event)"
    [modalProperties]="modalProperties"
    [username]="modalProperties.username"
    [siteId]="modalProperties.siteId"
  ></ziro-voicemail>
</div>

<ng-template #errorTemplate>
  @if (!areFormsValid) {
    <span>{{ 'tkey;validators.global.required.missing.error' | translate }}</span>
  }
</ng-template>
